import { patchRangeCloneContents } from "./patchRangeCloneContents.js";
export function withRangeCloneContentsPatched(callback) {
  var undo = patchRangeCloneContents();

  try {
    callback();
  } finally {
    undo();
  }
}